export default [
  {
    path: '/activity-20260110-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2026-01-30T23:59:59.000+08:00', title: '奇幻秘境宝藏', id: 16 },
  },
  {
    path: '/activity-20260110-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2026-01-30T23:59:59.000+08:00', title: '奇幻秘境宝藏-规则', id: 16 },
  },
]
